"use client";

export default function GlobalError({ error, reset }) {
  return (
    <html>
      <body>
        <div className="errorPage">
          <h1>Something went wrong!</h1>
          <p>{error.message}</p>
          <button onClick={() => reset()}>Try again</button>
        </div>
      </body>
    </html>
  );
}
